<template>
  <b-col cols="12" style="border: 1px solid #cecece">
    <b-overlay :show="getProcessingLicense" rounded="sm">
      <b-tabs>
        <!-- permiso -->
        <b-tab title="Permiso">
          <license v-if="show" />
        </b-tab>

        <!-- respuesta -->
        <b-tab title="Respuesta" active>
          <approval
            ref="approval"
            v-if="show"
            :is-edit="isEditApproval"
            :object-edit="objectEditApproval"
          />
        </b-tab>

        <b-tab
          title="Retractación"
          :active="isEditRetraction"
          v-if="
            canWithCode(
              'business-partner',
              'solicitante-sindical',
              'aprobador'
            ) && isEditRetraction
          "
        >
          <retraction
            :is-edit="isEditRetraction"
            :object-edit="objectEditRetraction"
            @change:canBeDownloaded="changedCanBeDownload"
          />
        </b-tab>

        <!-- options -->
        <template #tabs-end>
          <li class="nav-item align-self-center pl-2">Descargar PDF's:</li>
          <li class="nav-item align-self-center pl-3">
            <a :href="downloadLicense" target="_blank"> Permiso </a>
          </li>
          <li
            class="nav-item align-self-center pl-1"
            v-if="can_be_downloaded_approval"
          >
            <a :href="downloadResponse()" target="_blank"> - Respuesta </a>
          </li>
          <li
            class="nav-item align-self-center pl-1"
            v-if="can_be_downloaded_retraction"
          >
            <a :href="downloadResponse('retraction')" target="_blank">
              - Retractación
            </a>
          </li>
        </template>
      </b-tabs>
    </b-overlay>
  </b-col>
</template>

<script>
import controller from "./controller";
const { script } = controller();
export default script;
</script>

<style lang="scss" src="./styles.scss" />
